// extracted by mini-css-extract-plugin
export default {"phone":"Phone_phone__vN+jw"};